export const formatAccountingOptionLabel = (code?: string | number | null, name?: string | null): string => {
  const normalizedCode = String(code || '').trim()
  const normalizedName = String(name || '').trim()
  if (normalizedCode && normalizedName) {
    return `${normalizedCode} - ${normalizedName}`
  }
  return normalizedCode || normalizedName || '-'
}

export const collectMissingAssignedQuotationAccounting = (assignedLines?: any[]) => {
  const relevantLines = (assignedLines || []).filter(
    (line) => line && Number(line.assignedQuantity || 0) > 0
  )

  return relevantLines
    .map((line) => {
      const missing: string[] = []
      if (!(Number(line.accountCodeId || 0) > 0)) {
        missing.push('accountCode')
      }
      if (!(Number(line.subaccountCodeId || 0) > 0)) {
        missing.push('subaccountCode')
      }
      if (missing.length === 0) {
        return null
      }
      return {
        requisitionLineId:
          line.requisitionLineId !== null && line.requisitionLineId !== undefined
            ? Number(line.requisitionLineId)
            : null,
        missing,
      }
    })
    .filter(Boolean) as { requisitionLineId: number | null, missing: string[] }[]
}

export const validateAssignedQuotationAccountingLines = (assignedLines?: any[]): string | null => {
  const missingLines = collectMissingAssignedQuotationAccounting(assignedLines)
  if (missingLines.length === 0) {
    return null
  }
  const hasMissingAccount = missingLines.some((line) => line.missing.includes('accountCode'))
  if (hasMissingAccount) {
    return 'Account Code is required for every allocated quotation line.'
  }
  return 'Sub-account Code is required for every allocated quotation line.'
}
